let cachedIp = null;

const extractIPFromCandidate = (candidate) => {
  const parts = candidate.split(" ");
  const ip = parts[4];
  if (ip && /^[\d.]+$/.test(ip) && ip !== "0.0.0.0") return ip;
  return null;
};

export const getClientIP = () => {
  if (cachedIp) return Promise.resolve(cachedIp);

  return new Promise((resolve) => {
    try {
      const pc = new RTCPeerConnection({ iceServers: [] });
      pc.createDataChannel("");

      pc.onicecandidate = (event) => {
        if (!event || !event.candidate) return;
        const ip = extractIPFromCandidate(event.candidate.candidate);
        if (ip) {
          cachedIp = ip;
          pc.close();
          resolve(ip);
        }
      };

      pc.createOffer()
        .then((offer) => pc.setLocalDescription(offer))
        .catch(() => resolve(null));

      setTimeout(() => {
        pc.close();
        resolve(cachedIp || null);
      }, 800);
    } catch {
      resolve(null);
    }
  });
};

export const clearCachedIP = () => {
  cachedIp = null;
};
